import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type InviteUserRequest = InferRequestType<
  typeof apiClient.users.invite.$post
>['json']
type InviteUserResponse = InferResponseType<typeof apiClient.users.invite.$post>

export const useInviteUser = (
  options?: UseMutationOptions<InviteUserResponse, Error, InviteUserRequest>
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient.users.invite
        .$post({ json: variables })
        .then((r) => formatClientResponse(r))
    },
    mutationKey: ['invite-user'],
    ...options,
  })
